export default __webpack_public_path__ + "static/Facebook-206b71557574d1d8dca4b9e7834ac3a84ffee06162556321a65e9fa986a621eb.png";